/* eslint-disable no-unused-vars */
import ApiService from "../../api.service";
import appConfig from "../../../../app-config";

ApiService.init(appConfig.VUE_APP_ROOT_API);

const CustomerContractLineDescriptionService = {

  async checkInactiveValidation(code) {
    const requestScreenData = {
      url: "api/CustomerSalesContractLineDescription/CanDisable/" + code
    };

    return await ApiService.oDataGet(requestScreenData);
  },
};

export { CustomerContractLineDescriptionService };
